import { includes } from 'lodash';
import React, { CSSProperties, HTMLAttributes, ReactNode, SFC } from 'react';
import Arrow, { ArrowDirection } from '../Arrow';
import Paper, { PaperProps } from '../Paper';
import { WithStyles, createStyles, withStyles } from '../styles';
import { cx } from '../utils';

const styles = createStyles<'root'>(theme => ({
  root: {
    border: `1px solid ${theme.color('grey', '200')}`,
    borderRadius: 2,
    position: 'relative',
  },
}));

export type ArrowBoxProps = {
  arrowLeft?: number;
  arrowTop?: number;
  children?: ReactNode;
  color?: string;
  direction?: ArrowDirection;
  domRef?: (el: HTMLDivElement | null) => void;
  size?: number;
} & HTMLAttributes<HTMLDivElement> &
  Pick<PaperProps, 'elevation'>;

type Props = WithStyles<ArrowBoxProps, typeof styles>;

const calculateArrowStyle = (
  props: Pick<Props, 'arrowLeft' | 'arrowTop' | 'direction'>,
): CSSProperties => ({
  left:
    includes(['up', 'down'], props.direction) && props.arrowLeft
      ? `${props.arrowLeft}px`
      : undefined,
  top:
    includes(['left', 'right'], props.direction) && props.arrowTop
      ? `${props.arrowTop}px`
      : undefined,
});

const ArrowBox: SFC<Props> = ({
  arrowLeft,
  arrowTop,
  children,
  classes,
  className,
  color,
  direction,
  elevation = 9,
  size,
  theme,
  ...props
}) => (
  <Paper
    className={cx(classes.root, className)}
    elevation={elevation}
    {...props}
  >
    {children}
    <Arrow
      color={color}
      size={size}
      direction={direction}
      style={calculateArrowStyle({ arrowLeft, arrowTop, direction })}
    />
  </Paper>
);

export default withStyles(styles)(ArrowBox);
